module.exports = __webpack_public_path__ + "media/images/upload-icon-ea7aa965527e190cdb6e9717a3c94eee.svg";